export const numberSelectCard = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
];

export const classes = [
  { label: "Mago", value: "Mago" },
  { label: "Paladino", value: "Paladino" },
  { label: "Caçador", value: "Caçador" },
  { label: "Druida", value: "Druida" },
];

export const tipoCard = [
  { label: "Magia", value: "Magia" },
  { label: "Criatura", value: "Criatura" },
];
